import { useLevel1SectionData } from '../useLevel1Section';

const skipKeys = ['under_hood_3_point_body_lines_paint_check', 'frame_fit_finish_under_hood'];

export const useUnderHoodSections = () => {
  const { subSections } = useLevel1SectionData('under_hood');
  return Object.values(subSections).filter(s => !skipKeys.includes(s.name));
};
